"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecretQueriesImpl = exports.SecretQueries = void 0;
const contract_hash_1 = require("./contract-hash");
const secret20_contract_info_1 = require("./secret20-contract-info");
const secret20_balance_1 = require("./secret20-balance");
exports.SecretQueries = {
    use(options) {
        return (queriesSetBase, kvStore, chainId, chainGetter) => {
            return {
                secret: new SecretQueriesImpl(queriesSetBase, kvStore, chainId, chainGetter, options.apiGetter),
            };
        };
    },
};
class SecretQueriesImpl {
    constructor(base, kvStore, chainId, chainGetter, apiGetter) {
        this.querySecretContractCodeHash = new contract_hash_1.ObservableQuerySecretContractCodeHash(kvStore, chainId, chainGetter);
        base.queryBalances.addBalanceRegistry(new secret20_balance_1.ObservableQuerySecret20BalanceRegistry(kvStore, apiGetter, this.querySecretContractCodeHash));
        this.querySecret20ContractInfo = new secret20_contract_info_1.ObservableQuerySecret20ContractInfo(kvStore, chainId, chainGetter, apiGetter, this.querySecretContractCodeHash);
    }
}
exports.SecretQueriesImpl = SecretQueriesImpl;
//# sourceMappingURL=queries.js.map